import Close from '@mui/icons-material/Close';
import React, { PureComponent } from 'react';

import Button from '../Button/Button';

interface NotificationActionButtonsProps {
  onClick?: (key: string) => void;
  children?: React.ReactNode;
  key?: string;
  close?: boolean;
  actionColor?: string;
  actionTitle?: string;
  dismissNotification?: (key: string) => void;
}

class NotificationActionButtons extends PureComponent<NotificationActionButtonsProps> {
  render() {
    //receives notification key
    const {
      key,
      close,
      onClick,
      children,
      actionColor,
      actionTitle,
      dismissNotification,
    } = this.props;
    if (!onClick && !close) {
      console.warn(
        'Dont call NotificationActionButton without close or onClick'
      );
    }
    return (
      <>
        {onClick && children && (
          <Button
            tooltip={actionTitle || ''}
            color={
              (actionColor as
                | 'white'
                | 'primary'
                | 'secondary'
                | 'success'
                | 'info'
                | 'warning'
                | 'danger'
                | 'gray'
                | 'transparent') || 'white'
            }
            justIcon
            size="small"
            onClick={() => key && onClick(key)}
          >
            {children}
          </Button>
        )}
        {close && (
          <Button
            tooltip="Close"
            color="white"
            justIcon
            size="small"
            onClick={() =>
              key && dismissNotification && dismissNotification(key)
            }
          >
            <Close />
          </Button>
        )}
      </>
    );
  }
}

export default NotificationActionButtons;
